import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getArchivedServices, getArchivedVideos, getProviderAllServices, StateStatus } from '@guryou/redux';
import { resetState } from '../actions';
import { PROVIDER_ARCHIVED_SERVICES_GET_MANY, PROVIDER_ARCHIVED_VIDEOS, PROVIDER_RESTORE_SERVICE, PROVIDER_RESTORE_VIDEO, PROVIDER_SERVICES_GET_MANY_ALL } from '../new';
const useArchivedServices = _ref => {
  let {
    type,
    all = false
  } = _ref;
  const serviceType = type ? 'services' : 'videos';
  const dispatch = useDispatch();
  const {
    archived: {
      data,
      status,
      version,
      entity
    },
    archivedAndNonArchived: {
      data: data2,
      status: status2,
      version: version2,
      entity: entity2
    },
    restore
  } = useSelector(state => state[serviceType]);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      if (type) {
        if (all) {
          dispatch(getProviderAllServices(type));
        } else {
          dispatch(getArchivedServices(type));
        }
      }
      if (!type) {
        dispatch(getArchivedVideos());
      }
    }
    if (restore.version) {
      if (type) {
        if (all) {
          dispatch(resetState(PROVIDER_SERVICES_GET_MANY_ALL));
        }
        dispatch(resetState(PROVIDER_ARCHIVED_SERVICES_GET_MANY));
        restore.version && dispatch(resetState(PROVIDER_RESTORE_SERVICE));
      }
      if (!type) {
        dispatch(resetState(PROVIDER_ARCHIVED_VIDEOS));
        restore.version && dispatch(resetState(PROVIDER_RESTORE_VIDEO));
      }
    }
  }, [dispatch, status, type, restore.version, all]);
  useEffect(() => {
    return () => {
      if (type) {
        dispatch(resetState(PROVIDER_ARCHIVED_SERVICES_GET_MANY));
        dispatch(resetState(PROVIDER_SERVICES_GET_MANY_ALL));
      }
      if (!type) {
        dispatch(resetState(PROVIDER_ARCHIVED_VIDEOS));
      }
    };
  }, [dispatch, type]);
  if (all && data2) {
    return {
      data: data2 || [],
      status: status2,
      version: version2,
      entity: entity2
    };
  }
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useArchivedServices;